import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  class: "card-title d-flex justify-content-between",
  style: {"width":"100%"}
}
const _hoisted_4 = {
  class: "fs-6",
  style: {"color":"lightgray","max-width":"750px"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  style: {"height":"300px"},
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_7 = {
  key: 1,
  class: "card-body"
}
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body copy-area" }
const _hoisted_10 = { class: "fs-4 mb-4" }
const _hoisted_11 = { class: "d-flex fs-4" }
const _hoisted_12 = { class: "me-4" }
const _hoisted_13 = { class: "me-4" }
const _hoisted_14 = { class: "me-4" }
const _hoisted_15 = { class: "me-4" }
const _hoisted_16 = { class: "d-flex fs-4" }
const _hoisted_17 = { class: "me-4" }
const _hoisted_18 = { class: "me-4" }
const _hoisted_19 = { class: "me-4" }
const _hoisted_20 = { class: "me-4" }
const _hoisted_21 = { class: "me-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "fs-3 mt-2" }, "Current Positions:", -1)
const _hoisted_23 = { class: "d-flex fs-4" }
const _hoisted_24 = { class: "me-4" }
const _hoisted_25 = { class: "me-4" }
const _hoisted_26 = { class: "me-4" }
const _hoisted_27 = { class: "me-4" }
const _hoisted_28 = { class: "d-flex gap-4" }
const _hoisted_29 = { class: "fs-3 mt-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "fs-3 mt-2" }, "Current Price ( bid / ask ):", -1)
const _hoisted_31 = { class: "d-flex fs-4" }
const _hoisted_32 = { class: "me-4" }
const _hoisted_33 = { class: "me-4" }
const _hoisted_34 = { class: "row rol-cols-2 gap-5 mt-5 px-2" }
const _hoisted_35 = { class: "col card" }
const _hoisted_36 = { class: "card-body" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "OPEN LONG", -1)
const _hoisted_38 = { class: "row row-cols-2" }
const _hoisted_39 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_40 = { class: "d-flex gap-6" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_43 = { class: "fs-4" }
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_46 = { class: "fs-4" }
const _hoisted_47 = { class: "col card" }
const _hoisted_48 = { class: "card-body" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "OPEN SHORT", -1)
const _hoisted_50 = { class: "row row-cols-2" }
const _hoisted_51 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_52 = { class: "d-flex gap-6" }
const _hoisted_53 = { class: "text-center" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_55 = { class: "fs-4" }
const _hoisted_56 = { class: "text-center" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_58 = { class: "fs-4" }
const _hoisted_59 = { class: "row rol-cols-2 gap-5 mt-5 px-2" }
const _hoisted_60 = { class: "col card" }
const _hoisted_61 = { class: "card-body" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "CLOSED LONG", -1)
const _hoisted_63 = { class: "row row-cols-2" }
const _hoisted_64 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_65 = { class: "d-flex gap-6" }
const _hoisted_66 = { class: "text-center" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_68 = { class: "fs-4" }
const _hoisted_69 = { class: "text-center" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_71 = { class: "fs-4" }
const _hoisted_72 = { class: "text-center" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "PROFIT", -1)
const _hoisted_74 = { class: "fs-4" }
const _hoisted_75 = { class: "col card" }
const _hoisted_76 = { class: "card-body" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "CLOSED SHORT", -1)
const _hoisted_78 = { class: "row row-cols-2" }
const _hoisted_79 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_80 = { class: "d-flex gap-6" }
const _hoisted_81 = { class: "text-center" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_83 = { class: "fs-4" }
const _hoisted_84 = { class: "text-center" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_86 = { class: "fs-4" }
const _hoisted_87 = { class: "row rol-cols-2 gap-5 mt-5 px-2" }
const _hoisted_88 = { class: "col card" }
const _hoisted_89 = { class: "card-body" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "CURRENT LONG", -1)
const _hoisted_91 = { class: "row row-cols-2" }
const _hoisted_92 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_93 = { class: "d-flex gap-6" }
const _hoisted_94 = { class: "text-center" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_96 = { class: "fs-4" }
const _hoisted_97 = { class: "text-center" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_99 = { class: "fs-4" }
const _hoisted_100 = { class: "text-center" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "SL", -1)
const _hoisted_102 = { class: "fs-4" }
const _hoisted_103 = { class: "text-center" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "TP", -1)
const _hoisted_105 = { class: "fs-4" }
const _hoisted_106 = { class: "col card" }
const _hoisted_107 = { class: "card-body" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "CURRENT SHORT", -1)
const _hoisted_109 = { class: "row row-cols-2" }
const _hoisted_110 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_111 = { class: "d-flex gap-6" }
const _hoisted_112 = { class: "text-center" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_114 = { class: "fs-4" }
const _hoisted_115 = { class: "text-center" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_117 = { class: "fs-4" }
const _hoisted_118 = { class: "text-center" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "SL", -1)
const _hoisted_120 = { class: "fs-4" }
const _hoisted_121 = { class: "text-center" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "TP", -1)
const _hoisted_123 = { class: "fs-4" }
const _hoisted_124 = { class: "card mt-5" }
const _hoisted_125 = { class: "card-body" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold" }, "Summary", -1)
const _hoisted_127 = { class: "row row-cols-2" }
const _hoisted_128 = { class: "col" }
const _hoisted_129 = { class: "d-flex gap-10 mt-4" }
const _hoisted_130 = { class: "fs-2" }
const _hoisted_131 = { style: {"color":"#5cb85c"} }
const _hoisted_132 = { class: "fs-2" }
const _hoisted_133 = { style: {"color":"#5cb85c"} }
const _hoisted_134 = { class: "fs-2" }
const _hoisted_135 = { style: {"color":"#5cb85c"} }

import { ref, inject, computed, onMounted, watch } from "vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { ElMessage } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import filters from "@/core/helpers/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'BriefDetailTradeStat',
  props: {
    accountId: {},
    fromBrirfDetail: { type: Boolean },
    accountNumbers: {},
    period: {}
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(false);
const data = ref<any>({});
const isSearched = ref(false);
const accountDetail = props.fromBrirfDetail
  ? {}
  : inject(AccountInjectionKeys.ACCOUNT_DETAILS);

const currencyShow = (_balance: any) => {
  return new Intl.NumberFormat().format(_balance);
};

const fetchData = async () => {
  console.log(props.period);
  isSearched.value = true;
  isLoading.value = true;

  try {
    const res = await AccountService.queryTradeStatByAccountNumbers({
      accountNumbers: props.accountNumbers
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== ""),
      from: props.period[0],
      to: props.period[1],
    });
    data.value = res;
  } catch (error) {
    MsgPrompt.error(error);
    isSearched.value = false;
  }
  isLoading.value = false;
};

const copyText = () => {
  let textToCopy = `${props.accountNumbers
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item !== "")}\n\n`;
  // Add openTradeStats

  data.value.openTradeStats.forEach((item) => {
    textToCopy += `New ${item.cmd == 0 ? "BUY" : "SELL"} ${item.volume} LOT ${
      item.symbol
    } @ AVG: ${item.averagePrice}\n`;
  });
  // Add closedTradeStats
  data.value.closedTradeStats.forEach((item) => {
    textToCopy += `CLOSED ${item.cmd == 0 ? "BUY" : "SELL"} ${
      item.volume
    } LOT ${item.symbol} @ AVG: ${currencyShow(
      item.averagePrice
    )} PL: ${currencyShow(item.profit)}\n`;
  });

  // Add openTrades
  textToCopy += "\nCurrent Positions:\n";

  data.value.openTrades.forEach((item) => {
    // const avgPrice = (item.openPrice + item.closePrice) / 2;
    textToCopy += `${item.cmd == 0 ? "LONG" : "SHORT"} ${item.volume} LOT ${
      item.symbol
    } @ AVG: ${item.averagePrice}\n`;
  });

  // Add equity and balance
  textToCopy += `\nEquity: ${currencyShow(data.value.equity)}\n`;

  // Add openTradeCurrentPrices
  textToCopy += "\nCurrent Price ( bid / ask ):\n";
  data.value.openTradeCurrentPrices.forEach((item) => {
    textToCopy += `${item.symbol}: ${item.bid} / ${currencyShow(item.ask)}\n`;
  });

  // Copy to clipboard
  navigator.clipboard
    .writeText(textToCopy)
    .then(() => {
      ElMessage.success("Copied to clipboard");
    })
    .catch((err) => {
      console.error("Failed to copy text: ", err);
    });
};

watch(
  () => props.period,
  () => {
    fetchData();
  }
);

watch(
  () => props.accountNumbers,
  () => {
    fetchData();
  }
);

onMounted(async () => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, "Search Account: " + _toDisplayString(props.accountNumbers), 1),
          _createElementVNode("div", null, "Search Period: " + _toDisplayString(props.period), 1)
        ]),
        (isSearched.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              plain: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (copyText())),
              disabled: isLoading.value,
              class: "ms-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.copy")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (isSearched.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(ScaleLoader, { color: '#ffc730' })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(props.accountNumbers
                  .split(",")
                  .map((item) => item.trim())
                  .filter((item) => item !== "")
                  .join(", ")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTradeStats, (item) => {
                      return (_openBlock(), _createElementBlock("div", { key: item }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, "New " + _toDisplayString(item.cmd == 0 ? "BUY" : "SELL"), 1),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(item.volume + " LOT"), 1),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(item.symbol), 1),
                          _createElementVNode("div", _hoisted_15, _toDisplayString("@ AVG: " + item.averagePrice), 1)
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.closedTradeStats, (item) => {
                      return (_openBlock(), _createElementBlock("div", { key: item }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, " CLOSED " + _toDisplayString(item.cmd == 0 ? "BUY" : "SELL"), 1),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(item.volume + " LOT"), 1),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.symbol), 1),
                          _createElementVNode("div", _hoisted_20, _toDisplayString("@ AVG: " + item.averagePrice), 1),
                          _createElementVNode("div", _hoisted_21, _toDisplayString("PL: " + currencyShow(item.profit)), 1)
                        ])
                      ]))
                    }), 128)),
                    _hoisted_22,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTrades, (item) => {
                      return (_openBlock(), _createElementBlock("div", { key: item }, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString(item.cmd == 0 ? "LONG" : "SHORT"), 1),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(item.volume + " LOT"), 1),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(item.symbol), 1),
                          _createElementVNode("div", _hoisted_27, _toDisplayString("@ AVG: " + item.averagePrice), 1)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, " Equity: " + _toDisplayString(currencyShow(data.value.equity)), 1)
                    ]),
                    _hoisted_30,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTradeCurrentPrices, (item) => {
                      return (_openBlock(), _createElementBlock("div", { key: item }, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(item.symbol) + ":", 1),
                          _createElementVNode("div", _hoisted_33, _toDisplayString(item.bid) + " / " + _toDisplayString(item.ask), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("div", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTradeStats.filter(
                    (item) => item.cmd == 0
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_39, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _hoisted_42,
                                _createElementVNode("div", _hoisted_43, _toDisplayString(item.averagePrice), 1)
                              ]),
                              _createElementVNode("div", _hoisted_44, [
                                _hoisted_45,
                                _createElementVNode("div", _hoisted_46, _toDisplayString(item.volume), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("div", _hoisted_50, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTradeStats.filter(
                    (item) => item.cmd == 1
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_51, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _hoisted_54,
                                _createElementVNode("div", _hoisted_55, _toDisplayString(item.averagePrice), 1)
                              ]),
                              _createElementVNode("div", _hoisted_56, [
                                _hoisted_57,
                                _createElementVNode("div", _hoisted_58, _toDisplayString(item.volume), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("div", _hoisted_63, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.closedTradeStats.filter(
                    (item) => item.cmd == 0
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_64, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                _hoisted_67,
                                _createElementVNode("div", _hoisted_68, _toDisplayString(item.averagePrice), 1)
                              ]),
                              _createElementVNode("div", _hoisted_69, [
                                _hoisted_70,
                                _createElementVNode("div", _hoisted_71, _toDisplayString(item.volume), 1)
                              ]),
                              _createElementVNode("div", _hoisted_72, [
                                _hoisted_73,
                                _createElementVNode("div", _hoisted_74, _toDisplayString(item.profit), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("div", _hoisted_78, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.closedTradeStats.filter(
                    (item) => item.cmd == 1
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_79, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("div", _hoisted_81, [
                                _hoisted_82,
                                _createElementVNode("div", _hoisted_83, _toDisplayString(item.averagePrice), 1)
                              ]),
                              _createElementVNode("div", _hoisted_84, [
                                _hoisted_85,
                                _createElementVNode("div", _hoisted_86, _toDisplayString(item.volume), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _hoisted_90,
                      _createElementVNode("div", _hoisted_91, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTrades.filter(
                    (item) => item.cmd == 0
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_92, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_93, [
                              _createElementVNode("div", _hoisted_94, [
                                _hoisted_95,
                                _createElementVNode("div", _hoisted_96, _toDisplayString((item.openPrice + item.closePrice) / 2), 1)
                              ]),
                              _createElementVNode("div", _hoisted_97, [
                                _hoisted_98,
                                _createElementVNode("div", _hoisted_99, _toDisplayString(item.volume), 1)
                              ]),
                              _createElementVNode("div", _hoisted_100, [
                                _hoisted_101,
                                _createElementVNode("div", _hoisted_102, _toDisplayString(item.sl), 1)
                              ]),
                              _createElementVNode("div", _hoisted_103, [
                                _hoisted_104,
                                _createElementVNode("div", _hoisted_105, _toDisplayString(item.tp), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_106, [
                    _createElementVNode("div", _hoisted_107, [
                      _hoisted_108,
                      _createElementVNode("div", _hoisted_109, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTrades.filter(
                    (item) => item.cmd == 1
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_110, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_111, [
                              _createElementVNode("div", _hoisted_112, [
                                _hoisted_113,
                                _createElementVNode("div", _hoisted_114, _toDisplayString((item.openPrice + item.closePrice) / 2), 1)
                              ]),
                              _createElementVNode("div", _hoisted_115, [
                                _hoisted_116,
                                _createElementVNode("div", _hoisted_117, _toDisplayString(item.volume), 1)
                              ]),
                              _createElementVNode("div", _hoisted_118, [
                                _hoisted_119,
                                _createElementVNode("div", _hoisted_120, _toDisplayString(item.sl), 1)
                              ]),
                              _createElementVNode("div", _hoisted_121, [
                                _hoisted_122,
                                _createElementVNode("div", _hoisted_123, _toDisplayString(item.tp), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_124, [
                  _createElementVNode("div", _hoisted_125, [
                    _hoisted_126,
                    _createElementVNode("div", _hoisted_127, [
                      _createElementVNode("div", _hoisted_128, [
                        _createElementVNode("div", _hoisted_129, [
                          _createElementVNode("div", _hoisted_130, [
                            _createTextVNode(" Equity: "),
                            _createElementVNode("span", _hoisted_131, _toDisplayString(data.value.equity), 1)
                          ]),
                          _createElementVNode("div", _hoisted_132, [
                            _createTextVNode(" Balance: "),
                            _createElementVNode("span", _hoisted_133, _toDisplayString(data.value.balance), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_134, [
                          _createElementVNode("div", null, [
                            _createTextVNode(" Timestamp: "),
                            _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.period[1]), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})